import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchContent = (params) =>
  HttpClient().get('/labels/v2', {
    params: {
      brand_id: params.brandId,
      per_page: params.perPage,
      page: params.page,
      include: 'label_set',
    },
  })

const getLabelsV2 =
  ({ brandId, page = 1, perPage = 500 }) =>
  (dispatch) =>
    fetchContent({
      page,
      brandId,
      perPage,
    })
      .then((response) => dispatch(loadJsonApiEntities(response.data)))
      .catch((err) => {
        console.log(err)
        throw err
      })

export default getLabelsV2
